var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticClass: "labelStyle" },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("app-display", {
                attrs: {
                  label: "Localizações:",
                  content: _vm.dadosJson.georreferenciamento.localizacoes.length
                    ? "Sim"
                    : "Não"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Denominação:",
                  content: _vm.dadosJson.georreferenciamento.denominacao || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Possui Georreferenciamento:",
                  content:
                    _vm.dadosJson.georreferenciamento
                      .possuiGeorreferenciamento || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Nome do Responsável:",
                  content:
                    _vm.dadosJson.georreferenciamento.responsavel.nome || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Código INCRA do Responsável:",
                  content:
                    _vm.dadosJson.georreferenciamento.responsavel.codigoIncra ||
                    "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "CREA/RNP do Responsável:",
                  content:
                    _vm.dadosJson.georreferenciamento.responsavel.creaRnp || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Formação do Responsável:",
                  content:
                    _vm.dadosJson.georreferenciamento.responsavel.formacao ||
                    "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Código de Credenciamento do Responsável:",
                  content:
                    _vm.dadosJson.georreferenciamento.responsavel
                      .codigoCredenciamento || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Matrícula do Responsável:",
                  content:
                    _vm.dadosJson.georreferenciamento.responsavel.matricula ||
                    "-"
                }
              }),
              _c("app-display", { attrs: { label: "Documentos:" } }),
              _c(
                "ul",
                _vm._l(_vm.dadosJson.georreferenciamento.documentos, function(
                  documento
                ) {
                  return _c("li", { key: documento.id }, [
                    _vm._v(_vm._s(documento.nome))
                  ])
                }),
                0
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b2aaade4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b2aaade4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/GeorreferenciamentoRf.vue
// module id = null
// module chunks = 